import { forwardRef } from 'react'

import styles from './styles.module.css';

type Props = {
    type: 'item' | 'group'
} & React.HTMLProps<HTMLButtonElement>

export const Clickable = forwardRef<HTMLButtonElement, Props>(({type, className, ...props}, ref) => {
    const commonClassName = `${styles.root} ${type === 'item' ? styles.item : styles.group}`
    const _className = className ? `${className} ${commonClassName}` : commonClassName

    return (
        <button
            ref={ref}
            className={_className}
            {...props} />
    )
})
